import i18n from "@cirrus/legacy/app-common/alt/framework/i18n.js"
// @ts-ignore
import * as legacy from "@cirrus/legacy/app-common/alt/framework/displayUserData.es6"

export function displayAnonymousUserData(candidateIndex: string): string {
  return legacy.displayAnonymousUserData(candidateIndex)
}

export function displayUserData(value: string, isAnonymous: boolean, candidateIndex: string): string {
  return legacy.displayUserData(value, isAnonymous, candidateIndex)
}
